export function getNestedValue(data: object, key: string): any {
    let value: any = data;
    if (!key) {
        return value;
    }

    key.split('.').forEach((part) => {
        value = value[part] ?? '';
    });

    return value;
}

export function getNestedValues<T>(_data: T, key: string): any {
    let values: any[] = [_data];
    if (!key) {
        return values;
    }

    key.split('.').forEach((part) => {
        values = values.flatMap((it) => it[part] ?? null);
    });

    return values;
}

export function setNestedValues(data: object[], key: string, dataValues: any[]): object[] {
    if (!key) return data;

    let values: any[] = [data];
    let parts = key.split('.');
    parts = parts.slice(0, Math.max(parts.length - 1, 0));

    for (const part of parts) {
        values = values.flatMap((it) => it[part] ?? []);
    }

    for (let i = dataValues.length - 1; i >= 0; i--) {
        if (dataValues[i]) {
            Object.assign(values[i], dataValues[i]);
        } else {
            values[i].__toRemove = true;
        }
    }

    return data;
}

export function clearToRemoveObjects(data: any): void {
    if (Array.isArray(data)) {
        for (let i = data.length - 1; i >= 0; i--) {
            if (data[i]?.__toRemove === true || data[i]?.deletedAt) {
                data.splice(i, 1);
            }
        }
        data.forEach((it) => clearToRemoveObjects(it));
    } else if (typeof data === 'object') {
        Object.keys(data).forEach((it) => {
            data[it] && clearToRemoveObjects(data[it]);
        });
    }
}
